import "./TermsAndConditions.CSS";

const TermsOfService = () => {
  return (
    <div className="terms-container m-4 shadow-4 p-5 rounded">
      <h1 className="terms-title">Terms of Service</h1>
      <p className="terms-date">Effective Date: [29-04-2025]</p>
      <p className="terms-website">Website: https://kidschoice.co.in</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using our website, you agree to be bound by these Terms of Service
        and our Privacy Policy.
      </p>

      <h2>2. Use of the Website</h2>
      <p>
        You agree to use the website for lawful purposes only and not to violate
        any applicable laws or regulations.
      </p>

      <h2>3. Account Responsibility</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account
        and password and for all activities that occur under your account.
      </p>

      <h2>4. Product Information</h2>
      <p>
        We strive to display accurate product details but do not guarantee the
        completeness or reliability of any information.
      </p>

      <h2>5. Orders and Payments</h2>
      <p>
        All orders are subject to acceptance and availability. We reserve the
        right to cancel any order at any time.
      </p>

      <h2>6. Returns and Refunds</h2>
      <p>
        Our return and refund policy is available on the Returns & Refunds page.
        Please read it before making a purchase.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        All content on this site, including images, text, and logos, is the
        property of Kids Choice and protected by copyright laws.
      </p>

      <h2>8. Limitation of Liability</h2>
      <p>
        We are not liable for any damages arising from the use or inability to
        use the website or products.
      </p>

      <h2>9. Termination</h2>
      <p>
        We reserve the right to terminate your access to the site without notice
        for any breach of these terms.
      </p>

      <h2>10. Changes to the Terms</h2>
      <p>
        We may update these Terms at any time. Continued use of the website
        means you accept any changes.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions about these Terms, contact us at:
        <br />
        Email: support@kidschoice.co.in
        <br />
        Website: https://kidschoice.co.in
      </p>
    </div>
  );
};

export default TermsOfService;
